// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 200 200%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%272%27 stitchTiles=%27stitch%27/%3E%3CfeColorMatrix values=%270 0 0 0 0.95  0 0 0 0 0.92  0 0 0 0 0.86  0 0 0 0.05 0%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Figtree:wght@300;400;500;600;700&family=Amiri:wght@400;700&family=Amiri+Quran&family=Scheherazade+New:wght@400;500;600;700&family=Noto+Naskh+Arabic:wght@400;500;600;700&family=Noto+Sans+Arabic:wght@400;500;600;700;800&family=Noto+Sans+Tamil:wght@300;400;500;600;700;800&family=Noto+Nastaliq+Urdu:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
    --background: 38 50% 98%;
    --foreground: 220 14% 18%;
    --card: 0 0% 100%;
    --card-foreground: 220 14% 18%;
    --popover: 0 0% 100%;
    --popover-foreground: 220 14% 18%;
    --primary: 162 86% 17%;
    --primary-foreground: 38 50% 98%;
    --secondary: 38 30% 94%;
    --secondary-foreground: 162 86% 17%;
    --muted: 38 30% 94%;
    --muted-foreground: 220 9% 40%;
    --accent: 32 95% 44%;
    --accent-foreground: 0 0% 100%;
    --destructive: 0 84% 60%;
    --destructive-foreground: 0 0% 98%;
    --border: 38 20% 88%;
    --input: 38 20% 88%;
    --ring: 162 86% 17%;
    --radius: 0.75rem;
  }

*{
  border-color: hsl(var(--border));
}

body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-inset-6{
  inset: -1.5rem;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1\\.5{
  bottom: -0.375rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-12{
  left: -3rem;
}
.-left-\\[14px\\]{
  left: -14px;
}
.-right-1{
  right: -0.25rem;
}
.-right-12{
  right: -3rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-12{
  top: -3rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-24{
  bottom: 6rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.end-0{
  inset-inline-end: 0px;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-3\\.5{
  right: 0.875rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[60\\]{
  z-index: 60;
}
.col-span-full{
  grid-column: 1 / -1;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.ms-auto{
  margin-inline-start: auto;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-\\[16\\/10\\]{
  aspect-ratio: 16/10;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-\\[4\\/5\\]{
  aspect-ratio: 4/5;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[50vh\\]{
  max-height: 50vh;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-16{
  min-height: 4rem;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[4\\.5rem\\]{
  min-height: 4.5rem;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-40{
  width: 10rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[11rem\\]{
  min-width: 11rem;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[2\\.5rem\\]{
  min-width: 2.5rem;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1024px\\]{
  max-width: 1024px;
}
.max-w-\\[1280px\\]{
  max-width: 1280px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[448px\\]{
  max-width: 448px;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[560px\\]{
  max-width: 560px;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[700px\\]{
  max-width: 700px;
}
.max-w-\\[768px\\]{
  max-width: 768px;
}
.max-w-\\[896px\\]{
  max-width: 896px;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-\\[calc\\(50\\%-0\\.375rem\\)\\]{
  flex-basis: calc(50% - 0.375rem);
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-8deg\\]{
  --tw-rotate: -8deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.6\\]{
  --tw-scale-x: 1.6;
  --tw-scale-y: 1.6;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#E7E0D2\\] > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(231 224 210 / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[2\\.5rem\\]{
  border-radius: 2.5rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-r-lg{
  border-top-right-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#064E3B\\]{
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity, 1));
}
.border-\\[\\#10B981\\]{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-\\[\\#A7F3D0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BFDBFE\\]{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D1FAE5\\]{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D97706\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D97706\\]\\/40{
  border-color: rgb(217 119 6 / 0.4);
}
.border-\\[\\#E7E0D2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(231 224 210 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EF4444\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EF4444\\]\\/40{
  border-color: rgb(239 68 68 / 0.4);
}
.border-\\[\\#F3EDE2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(243 237 226 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FECACA\\]{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FED7AA\\]{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FED7AA\\]\\/20{
  border-color: rgb(254 215 170 / 0.2);
}
.border-\\[\\#FED7AA\\]\\/40{
  border-color: rgb(254 215 170 / 0.4);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#047857\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#064E3B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#064E3B\\]\\/10{
  background-color: rgb(6 78 59 / 0.1);
}
.bg-\\[\\#064E3B\\]\\/40{
  background-color: rgb(6 78 59 / 0.4);
}
.bg-\\[\\#064E3B\\]\\/5{
  background-color: rgb(6 78 59 / 0.05);
}
.bg-\\[\\#064E3B\\]\\/60{
  background-color: rgb(6 78 59 / 0.6);
}
.bg-\\[\\#064E3B\\]\\/95{
  background-color: rgb(6 78 59 / 0.95);
}
.bg-\\[\\#0EA5E9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F766E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#10B981\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1877F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 119 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1D4ED8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#25D366\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7C3AED\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B45309\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D1FAE5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D97706\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D97706\\]\\/20{
  background-color: rgb(217 119 6 / 0.2);
}
.bg-\\[\\#DC2626\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7E0D2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 224 210 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECFDF5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EF4444\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EFF6FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3F4F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5EFE3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 239 227 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5EFE3\\]\\/50{
  background-color: rgb(245 239 227 / 0.5);
}
.bg-\\[\\#F9F5EE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 245 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAF7F0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 247 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDF8F0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 248 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDFBF7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 251 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDFBF7\\]\\/95{
  background-color: rgb(253 251 247 / 0.95);
}
.bg-\\[\\#FEE2E2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEF2F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEF3C7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF7ED\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFBEB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/5{
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/75{
  background-color: rgb(255 255 255 / 0.75);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#ECFDF5\\]{
  --tw-gradient-from: #ECFDF5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F58529\\]{
  --tw-gradient-from: #F58529 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 133 41 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FDFBF7\\]{
  --tw-gradient-from: #FDFBF7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 251 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFF7ED\\]{
  --tw-gradient-from: #FFF7ED var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFFBEB\\]{
  --tw-gradient-from: #FFFBEB var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#DD2A7B\\]{
  --tw-gradient-to: rgb(221 42 123 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #DD2A7B var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#F4FBF7\\]{
  --tw-gradient-to: rgb(244 251 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F4FBF7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FDFBF7\\]\\/95{
  --tw-gradient-to: rgb(253 251 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(253 251 247 / 0.95) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#8134AF\\]{
  --tw-gradient-to: #8134AF var(--tw-gradient-to-position);
}
.to-\\[\\#FDFBF7\\]{
  --tw-gradient-to: #FDFBF7 var(--tw-gradient-to-position);
}
.to-\\[\\#FED7AA\\]\\/40{
  --tw-gradient-to: rgb(254 215 170 / 0.4) var(--tw-gradient-to-position);
}
.to-\\[\\#FEF3C7\\]\\/60{
  --tw-gradient-to: rgb(254 243 199 / 0.6) var(--tw-gradient-to-position);
}
.to-\\[\\#FFFBEB\\]{
  --tw-gradient-to: #FFFBEB var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.fill-\\[\\#D97706\\]{
  fill: #D97706;
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[0\\.4em\\]{
  padding-bottom: 0.4em;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.05\\]{
  line-height: 1.05;
}
.leading-loose{
  line-height: 2;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.05em\\]{
  letter-spacing: 0.05em;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.22em\\]{
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#064E3B\\]{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#065F46\\]{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0ca30c\\]{
  --tw-text-opacity: 1;
  color: rgb(12 163 12 / var(--tw-text-opacity, 1));
}
.text-\\[\\#10B981\\]{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D4ED8\\]{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F2937\\]{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4B5563\\]{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4B5563\\]\\/50{
  color: rgb(75 85 99 / 0.5);
}
.text-\\[\\#4B5563\\]\\/70{
  color: rgb(75 85 99 / 0.7);
}
.text-\\[\\#6B7280\\]{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7C3AED\\]{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7F1D1D\\]{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-\\[\\#92400E\\]{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-\\[\\#991B1B\\]{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9A3412\\]{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9CA3AF\\]{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B45309\\]{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B91C1C\\]{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D97706\\]{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-\\[\\#DC2626\\]{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E7E0D2\\]{
  --tw-text-opacity: 1;
  color: rgb(231 224 210 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EF4444\\]{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FDFBF7\\]{
  --tw-text-opacity: 1;
  color: rgb(253 251 247 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FDFBF7\\]\\/70{
  color: rgb(253 251 247 / 0.7);
}
.text-\\[\\#FDFBF7\\]\\/75{
  color: rgb(253 251 247 / 0.75);
}
.text-\\[\\#FDFBF7\\]\\/80{
  color: rgb(253 251 247 / 0.8);
}
.text-\\[\\#FED7AA\\]{
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FED7AA\\]\\/60{
  color: rgb(254 215 170 / 0.6);
}
.text-\\[\\#FED7AA\\]\\/70{
  color: rgb(254 215 170 / 0.7);
}
.text-\\[\\#FED7AA\\]\\/80{
  color: rgb(254 215 170 / 0.8);
}
.text-\\[\\#FED7AA\\]\\/85{
  color: rgb(254 215 170 / 0.85);
}
.text-\\[\\#FED7AA\\]\\/90{
  color: rgb(254 215 170 / 0.9);
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.underline{
  text-decoration-line: underline;
}
.decoration-dotted{
  text-decoration-style: dotted;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.accent-\\[\\#064E3B\\]{
  accent-color: #064E3B;
}
.opacity-0{
  opacity: 0;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-\\[0\\.35\\]{
  opacity: 0.35;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_3px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 0 0 3px rgba(16,185,129,0.18);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_3px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 0 0 3px rgba(239,68,68,0.18);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 0 0 4px rgba(16,185,129,0.18);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 0 0 4px rgba(239,68,68,0.18);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_-10px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 10px 30px -10px rgba(6,78,59,0.5);
  --tw-shadow-colored: 0 10px 30px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_-15px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 10px 30px -15px rgba(6,78,59,0.35);
  --tw-shadow-colored: 0 10px 30px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_-12px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 12px 32px -12px rgba(6,78,59,0.25);
  --tw-shadow-colored: 0 12px 32px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_-8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 12px 32px -8px rgba(0,0,0,0.28);
  --tw-shadow-colored: 0 12px 32px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_-8px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 12px 32px -8px rgba(16,185,129,0.55);
  --tw-shadow-colored: 0 12px 32px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_-10px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 12px 40px -10px rgba(6,78,59,0.18);
  --tw-shadow-colored: 0 12px 40px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_15px_50px_-15px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 15px 50px -15px rgba(6,78,59,0.35);
  --tw-shadow-colored: 0 15px 50px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-15px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 20px 50px -15px rgba(6,78,59,0.25);
  --tw-shadow-colored: 0 20px 50px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in{
  --tw-enter-opacity: 0;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-2{
  --tw-enter-translate-y: 0.5rem;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.duration-700{
  animation-duration: 700ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.\\!running{
  animation-play-state: running !important;
}
.running{
  animation-play-state: running;
}
.\\!paused{
  animation-play-state: paused !important;
}
.paused{
  animation-play-state: paused;
}

:root {
  --bg: #FDFBF7;
  --surface: #FFFFFF;
  --primary: #064E3B;
  --primary-hover: #047857;
  --accent: #D97706;
  --accent-hover: #B45309;
  --text: #1F2937;
  --text-soft: #4B5563;
  --border: #E7E0D2;
  --success: #10B981;
  --danger: #EF4444;

  /* ----------------------------------------------------------
     iOS safe areas (notch / Dynamic Island / home indicator)
     ----------------------------------------------------------
     index.html sets \`viewport-fit=cover\` together with
     \`apple-mobile-web-app-status-bar-style=black-translucent\`, and the
     manifest sets \`display: standalone\`. That combination tells iOS to
     draw the web view edge-to-edge — *underneath* the status bar and
     Dynamic Island — once the PWA is added to the home screen. Nothing
     compensated for it, so the sticky header (logo, A-/A+, language
     picker, Sign in) rendered beneath the clock and any incoming
     notification banner, where iOS keeps the touches for itself: those
     controls were both visually covered and untappable.

     env() reports how much each edge reserves, and resolves to the 0px
     fallback anywhere without insets — so all of this is inert on
     Android, desktop, and in a normal browser tab.
     ---------------------------------------------------------- */
  --safe-top: env(safe-area-inset-top, 0px);
  --safe-bottom: env(safe-area-inset-bottom, 0px);
  --safe-left: env(safe-area-inset-left, 0px);
  --safe-right: env(safe-area-inset-right, 0px);

  /* The header's own height (its \`min-h-16\` = 4rem) plus whatever the
     status bar reserves above it. Anything that sticks directly *below*
     the header has to offset by this, or it slides underneath once the
     header grows by the inset. */
  --header-offset: calc(4rem + var(--safe-top));
}

/* Sticky app header: push its contents clear of the status bar while the
   translucent background still bleeds up behind it, so the strip stays
   tinted instead of opening a bare gap above the header. The left/right
   insets matter in landscape, where the notch eats into one side. */
.safe-header {
  padding-top: var(--safe-top);
  padding-left: var(--safe-left);
  padding-right: var(--safe-right);
}

/* Toolbars that stick immediately beneath the app header. */
.sticky-below-header { top: var(--header-offset); }

/* Keeps trailing page content above the home indicator. */
.safe-bottom { padding-bottom: var(--safe-bottom); }

html, body, #root { background-color: var(--bg); color: var(--text); }
/* The header toolbar is ~23px wider than a 390px phone. Without this the phone widens its layout viewport, which pushes
   fixed-position controls (the demo strip, the chat button) partly off screen. \`clip\`, unlike \`hidden\`, keeps sticky headers working. */
html, body { overflow-x: clip; }

/* Alvi Nastaleeq's @font-face lives in public/fonts/alvi-nastaleeq.css,
   linked directly from index.html — NOT here. CRA's css-loader treats any
   url() inside webpack-processed CSS (this file) as a JS module request,
   even root-absolute ones like url('/fonts/...'), so it can't reference a
   plain public/ asset without failing to compile ("Cannot find module
   '/fonts/AlviNastaleeq.woff2'"). A separate stylesheet served as-is from
   public/ has no such restriction — the browser resolves its url()s
   against the site root like any other static CSS file. */

/* Urdu UI chrome — swaps the Noto Sans Arabic fallback (Naskh-style, used
   for Tamil/Arabic UI text generally) for the Nastaliq calligraphic style
   Urdu is conventionally set in. Scoped to [lang="ur"], which I18nContext
   stamps on <html> whenever the active UI language is Urdu, so switching
   back to any other language reverts instantly.

   Two Latin-type habits actively fight a cursive joined script and were
   the actual cause of the "clumsy/overlapping" look, not the font itself:
     - .font-heading's -0.01em letter-spacing (tight tracking reads as
       "modern" on Outfit's Latin glyphs) forces extra overlap on top of
       Nastaleeq's own designed joins, since the glyphs are already
       touching by design — needs resetting to normal, not just inherited.
     - The default ~1.2–1.5 line-height leaves no room for Nastaliq's
       steep diagonal ascender/descender strokes and stacked diacritics,
       which need roughly double a Latin line's height to clear the line
       above/below without visually colliding. */
/* Nastaliq's thin strokes and calligraphic proportions carry far less
   visual weight than a bold Latin sans at the same declared font-size —
   text that measures identically in px still *reads* noticeably smaller
   and lighter. The actual root font-size boost for Urdu lives in
   App.js's FontSizeDomSync, NOT as a plain \`html[lang="ur"] { font-size }\`
   rule here — the existing A-/A+ accessibility control
   (FontSizeContext) writes an inline style to <html>, which always wins
   over any stylesheet rule regardless of specificity, so a CSS-only
   attempt here would have silently done nothing. Scaling the root
   font-size (rather than font-size on individual text classes) is the
   right lever either way: nearly every size AND spacing utility in this
   app (text-*, p-*, gap-*, w-*, etc.) is expressed in rem, which resolves
   against <html>'s font-size — so one number grows text, padding, and
   gaps together in proportion, instead of enlarging only the glyphs and
   leaving them cramped inside now-too-small buttons/cards. */

html[lang="ur"] body,
html[lang="ur"] .font-body {
  font-family: 'Alvi Nastaleeq', 'Noto Nastaliq Urdu', 'Noto Sans Arabic', sans-serif;
  line-height: 2.1;
  letter-spacing: normal;
  font-weight: 400;
}
html[lang="ur"] .font-heading {
  font-family: 'Alvi Nastaleeq', 'Noto Nastaliq Urdu', 'Noto Sans Arabic', sans-serif;
  letter-spacing: normal;
  line-height: 1.9;
  font-weight: 400;
}

/* Client feedback: no bold in Alvi Nastaleeq, size only. The @font-face
   above only registers one weight (400, see alvi-nastaleeq.css) — every
   heading/button in the app applies a Tailwind weight utility on top
   (font-medium/semibold/bold) for the Latin faces, and with no matching
   700-weight file for Nastaleeq the browser was faking it by algorithmically
   thickening the strokes ("font synthesis"). That distorts a calligraphic,
   diagonally-joined script far more than it does a Latin sans — this is
   the actual cause of the heavy/clumsy look in the screenshot, not the
   font itself. Fix is two-layered: reset the common weight utilities back
   to the font's one true regular weight (specificity of an attribute
   selector + class beats a bare utility class, so this wins regardless of
   which order the classes were written in JSX), and disable font-synthesis
   outright as a backstop for anything not covered by name below. */
html[lang="ur"] .font-medium,
html[lang="ur"] .font-semibold,
html[lang="ur"] .font-bold,
html[lang="ur"] .font-extrabold {
  font-weight: 400;
}
html[lang="ur"] body {
  font-synthesis: none;
}

/* TAU_Elango_Kalyani's @font-face lives in public/fonts/kalyani.css,
   linked directly from index.html — same CRA css-loader constraint as
   Alvi Nastaleeq above. Scoped to [lang="ta"], which I18nContext stamps
   on <html> whenever the active UI language is Tamil.

   Majidi was tried first (see majidi.css, still self-hosted but unused
   below) — this replaced it as the active choice.

   Reported as "blurry at normal size, clear when zoomed in" — that's
   the signature of thin strokes not getting enough anti-aliased pixel
   coverage at typical UI text sizes, not a rendering bug. Confirmed via
   fontTools: this font's base letterforms fill only ~48% of the
   em-square (vs. a noticeably taller design in most UI-oriented Tamil
   fonts), so the same declared px font-size reads smaller/lighter than
   the Noto Sans Tamil fallback it replaced — same root cause as Alvi
   Nastaleeq's Urdu boost above, smaller correction since this is an
   upright script with no RTL joining to fight. font-synthesis: none is
   the backstop for the @font-face's 100–900 weight range in
   kalyani.css — belt-and-suspenders against any fake-bold slipping
   through. */
html[lang="ta"] body,
html[lang="ta"] .font-body {
  font-family: 'TAU Elango Kalyani', 'Noto Sans Tamil', sans-serif;
}
html[lang="ta"] .font-heading {
  font-family: 'TAU Elango Kalyani', 'Noto Sans Tamil', sans-serif;
}
html[lang="ta"] body {
  font-synthesis: none;
}

/* RTL icon mirroring — lucide-react auto-classes every icon it renders as
   \`lucide-{icon-name}\` (see createLucideIcon.js), so these are stable
   selector hooks with no per-usage markup needed. Play, Arrow-right/left,
   and Chevron-right/left icons read as "forward" (continue, next, tap-
   to-advance) everywhere they're
   used in this app; in a right-to-left layout "forward" points left, not
   right, so mirror them horizontally whenever the page itself is RTL
   (Urdu today — keyed on the \`dir\` attribute I18nContext sets on <html>,
   not on [lang="ur"] specifically, so any future RTL locale picks this up
   for free). Flipping both the *-right and *-left variants together swaps
   their meaning correctly instead of just rotating one of them wrong. */
html[dir="rtl"] .lucide-play,
html[dir="rtl"] .lucide-arrow-right,
html[dir="rtl"] .lucide-arrow-left,
html[dir="rtl"] .lucide-chevron-right,
html[dir="rtl"] .lucide-chevron-left {
  transform: scaleX(-1);
}

body {
  margin: 0;
  /* Figtree/Outfit only cover Latin glyphs, so switching the UI language to
     Tamil or Urdu previously fell through to whatever Tamil/Arabic font the
     visitor's OS happened to ship — an unpredictable fallback with taller
     glyph metrics than Figtree at the same font-size, which is what made
     translated UI chrome (nav, buttons, cards, forms) look larger and shift
     layout. Noto Sans Tamil / Noto Sans Arabic are explicitly designed by
     Google as part of the same Noto family for near-identical cap-height/
     x-height across scripts, so they slot in at the declared font-size
     without the layout-shifting side effect — this only ever engages for
     glyphs Figtree/Outfit don't have; English (and other Latin UI text:
     French, Bahasa Melayu, Swahili) is rendered in Figtree exactly as
     before. */
  font-family: 'Figtree', 'Noto Sans Tamil', 'Noto Sans Arabic', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg);
  background-image:
    radial-gradient(at 12% 8%, rgba(6,78,59,0.06) 0px, transparent 50%),
    radial-gradient(at 88% 92%, rgba(217,119,6,0.05) 0px, transparent 50%);
  background-attachment: fixed;
}

.font-heading { font-family: 'Outfit', 'Noto Sans Tamil', 'Noto Sans Arabic', sans-serif; letter-spacing: -0.01em; }
.font-body    { font-family: 'Figtree', 'Noto Sans Tamil', 'Noto Sans Arabic', sans-serif; }
.font-arabic  {
  font-family: 'Noto Sans Arabic', 'Scheherazade New', sans-serif;
  direction: rtl;
  font-feature-settings: "calt", "kern", "liga", "rlig", "mark", "mkmk";
  text-rendering: optimizeLegibility;
}

/* ============================================================
   SCRIPT (MUSHAF) SWITCHING
   ------------------------------------------------------------
   The .font-quran and .font-mushaf-prose classes change their
   underlying font-family based on the <html data-script>
   attribute set by ScriptSettingsContext.

   * Uthmani (default): Amiri Quran — the closest open-source
     match to the Madinah Mushaf. Used across the Arab world,
     Malaysia, Indonesia.
   * Indo-Pak:          Scheherazade New + Noto Naskh Arabic
     fallback — closely mirrors the Saleem/Noorehira glyph
     metrics popular in Pakistan, India, Bangladesh.

   Both share OpenType ligature features so "الله" renders with
   the correct dagger-alif and ligation in both modes.
   ============================================================ */
.font-quran   {
  /* default — overridden by [data-script=...] selectors below */
  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', serif;
  font-weight: 500;
  direction: rtl;
  font-feature-settings: "calt", "kern", "liga", "rlig", "dlig", "mark", "mkmk";
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}
.font-mushaf-prose {
  /* default — overridden by [data-script=...] selectors below */
  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Naskh Arabic', serif;
  font-weight: 500;
  direction: rtl;
  font-feature-settings: "calt", "kern", "liga", "rlig", "dlig", "mark", "mkmk";
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

html[data-script="uthmani"] .font-quran,
html[data-script="uthmani"] .font-mushaf-prose {
  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Naskh Arabic', serif;
}

html[data-script="indopak"] .font-quran,
html[data-script="indopak"] .font-mushaf-prose {
  font-family: 'Scheherazade New', 'Noto Naskh Arabic', 'Amiri', serif;
}

/* Visual-only preview helpers used by ScriptPicker so the side-by-side
   tiles always render in their intended font regardless of the current
   global selection. */
.font-preview-uthmani {
  font-family: 'Amiri Quran', 'Amiri', serif;
  font-weight: 500;
  direction: rtl;
  font-feature-settings: "calt", "kern", "liga", "rlig", "dlig", "mark", "mkmk";
  text-rendering: optimizeLegibility;
}
.font-preview-indopak {
  font-family: 'Scheherazade New', 'Noto Naskh Arabic', serif;
  font-weight: 500;
  direction: rtl;
  font-feature-settings: "calt", "kern", "liga", "rlig", "dlig", "mark", "mkmk";
  text-rendering: optimizeLegibility;
}
/* Madani-locked class — always uses Amiri Quran (KFGQPC Uthman Taha
   equivalent). Used by Module 9 so the final recitation always renders
   in the Madani Mushaf regardless of the user's script_preference. */
.font-madani {
  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Naskh Arabic', serif !important;
  font-weight: 500;
  direction: rtl;
  /* Generous line-height so dagger-alif (ٰ) + shaddah (ّ) marks don't
     collide with descenders on the line below. */
  line-height: 3.4;
  word-spacing: 0.15em;
  letter-spacing: 0;
  font-feature-settings: "calt", "kern", "liga", "rlig", "dlig", "mark", "mkmk", "ss01";
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}
/* Per-step size variants used by the Madani font-size picker on Module 9. */
.font-madani.size-sm { font-size: 1.5rem;   line-height: 3.0; }
.font-madani.size-md { font-size: 1.875rem; line-height: 3.4; }
.font-madani.size-lg { font-size: 2.375rem; line-height: 3.6; }
.font-madani.size-xl { font-size: 2.875rem; line-height: 3.8; }
/* Red-word highlight for Module 9 — words already practiced in Modules 1-7.
   Bolder, slightly larger, with a soft amber under-glow so they pop on the
   emerald background without looking pasted-on. */
.qf-red-word {
  color: #FCA5A5;
  font-weight: 700;
  text-shadow: 0 0 12px rgba(239, 68, 68, 0.45);
  padding: 0 0.05em;
  border-radius: 4px;
  background: linear-gradient(180deg, transparent 65%, rgba(239, 68, 68, 0.18) 65%);
}

/* Mushaf-style class — uses Scheherazade New (high-quality open Naskh that
   closely mirrors the Madinah Mushaf glyph metrics). */
.font-mushaf  {
  font-family: 'Scheherazade New', 'Amiri', serif;
  direction: rtl;
  font-feature-settings: "calt", "kern", "liga", "rlig", "mark", "mkmk";
  text-rendering: optimizeLegibility;
}

/* Arabic typography polish */
.font-arabic, .font-quran {
  line-height: 1.9;
  letter-spacing: 0;
  word-spacing: 0.05em;
  /* Prevent breaking inside a word and avoid the scattered-letter look */
  unicode-bidi: isolate;
}
/* When Quranic prose runs as a paragraph, keep words intact and let lines wrap
   naturally — overrides Tailwind's \`leading-loose\` so glyph stacks don't drift. */
.font-quran p,
.font-quran {
  word-break: keep-all;
  overflow-wrap: break-word;
}

/* Mushaf prose — Noto Naskh Arabic renders comfortably at 2.0 line-height
   (Amiri Quran needed 2.4 for stacked diacritics, Noto Naskh handles them
   inline so we can tighten the rhythm). */
.font-mushaf-prose {
  line-height: 2.0;
  letter-spacing: 0;
  word-spacing: 0.08em;
  unicode-bidi: isolate;
  word-break: keep-all;
  overflow-wrap: break-word;
}

/* Madinah-style Mushaf line — each line in a page is one stretched-justified row */
.mushaf-line-row {
  display: flex;
  flex-direction: row-reverse;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  font-size: clamp(1.6rem, 2.6vw, 2.4rem);
  line-height: 2.4;
  white-space: nowrap;
  overflow: hidden;
  text-align: justify;
  text-align-last: justify;
}
.mushaf-line-row > * { white-space: nowrap; }
.mushaf-line-short {
  /* Last line of a surah is naturally short — center it instead of stretching */
  justify-content: center;
  gap: 0.4em;
}

/* Subtle parchment grain */
.parchment {
  background-color: #FDFBF7;
  background-image:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Geometric pattern */
.pattern-islamic {
  background-image:
    radial-gradient(circle at 1px 1px, rgba(6,78,59,0.08) 1px, transparent 0);
  background-size: 24px 24px;
}

/* Waveform pulse for recording */
@keyframes pulseRing {
  0% { box-shadow: 0 0 0 0 rgba(6,78,59,0.4); }
  70% { box-shadow: 0 0 0 24px rgba(6,78,59,0); }
  100% { box-shadow: 0 0 0 0 rgba(6,78,59,0); }
}
.recording-ring { animation: pulseRing 1.4s ease-out infinite; }

@keyframes bar {
  0%, 100% { transform: scaleY(0.3); }
  50% { transform: scaleY(1); }
}
.wave-bar { animation: bar 0.9s ease-in-out infinite; transform-origin: bottom; }

/* Word card flip enter */
@keyframes flashIn {
  0% { opacity: 0; transform: scale(0.94); }
  100% { opacity: 1; transform: scale(1); }
}
.flash-in { animation: flashIn 240ms ease-out; }

/* Install surfaces (landing CTA + dashboard card) fade and slide in. They
   appear only once the browser fires \`beforeinstallprompt\`, which can land a
   moment after paint — so they'd otherwise pop in abruptly mid-page. */
@keyframes installReveal {
  0%   { opacity: 0; transform: translateY(10px); }
  100% { opacity: 1; transform: translateY(0); }
}
.install-reveal { animation: installReveal 420ms cubic-bezier(0.4, 0, 0.2, 1) both; }

/* Honour the OS "reduce motion" setting — the element still appears, it just
   arrives without the movement. */
@media (prefers-reduced-motion: reduce) {
  .install-reveal { animation: none; }
}

/* Mushaf reading transitions */
.mushaf-line { transition: background-color 200ms ease; }

/* Diff highlights for voice recitation */
.diff-ok { color: var(--text); }
.diff-sub { color: var(--danger); text-decoration: underline; text-decoration-style: wavy; text-decoration-color: rgba(239,68,68,0.6); }
.diff-miss { color: var(--danger); opacity: 0.55; text-decoration: line-through; }
.diff-extra { color: var(--accent); font-style: italic; }

/* Focus rings */
button:focus-visible, a:focus-visible, input:focus-visible, textarea:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
  border-radius: 6px;
}

/* Brand gradient text */
.brand-gradient {
  background: linear-gradient(115deg, #064E3B 0%, #047857 50%, #D97706 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-\\[\\#9CA3AF\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:pb-2:last-child{
  padding-bottom: 0.5rem;
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.focus-within\\:border-\\[\\#064E3B\\]:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity, 1));
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#064E3B\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#10B981\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#1D4ED8\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#7C3AED\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#B45309\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#D97706\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#EF4444\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.hover\\:border-white\\/30:hover{
  border-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-\\[\\#047857\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#059669\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#0D9668\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(13 150 104 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#0f63d1\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 99 209 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1DA851\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 168 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1E40AF\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a1a1a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#B45309\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#B91C1C\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#DC2626\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#ECFDF5\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F0EAE0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 234 224 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F9F5EE\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 245 238 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FDFBF7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 251 247 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FED7AA\\]\\/40:hover{
  background-color: rgb(254 215 170 / 0.4);
}
.hover\\:bg-\\[\\#FEE2E2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FEF2F2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FEF3C7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FFF7ED\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-black\\/10:hover{
  background-color: rgb(0 0 0 / 0.1);
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/70:hover{
  background-color: rgb(255 255 255 / 0.7);
}
.hover\\:bg-white\\/\\[0\\.08\\]:hover{
  background-color: rgb(255 255 255 / 0.08);
}
.hover\\:text-\\[\\#047857\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#064E3B\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1F2937\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#7F1D1D\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#B45309\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#D97706\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#DC2626\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#EF4444\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:shadow-\\[0_10px_30px_-15px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.2\\)\\]:hover{
  --tw-shadow: 0 10px 30px -15px rgba(6,78,59,0.2);
  --tw-shadow-colored: 0 10px 30px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_15px_40px_-20px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.25\\)\\]:hover{
  --tw-shadow: 0 15px 40px -20px rgba(6,78,59,0.25);
  --tw-shadow-colored: 0 15px 40px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_8px_24px_-12px_rgba\\(6\\2c 78\\2c 59\\2c 0\\.18\\)\\]:hover{
  --tw-shadow: 0 8px 24px -12px rgba(6,78,59,0.18);
  --tw-shadow-colored: 0 8px 24px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-\\[\\#064E3B\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#EF4444\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.focus\\:bg-\\[\\#FFF7ED\\]:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-\\[\\#D97706\\]:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 119 6 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-\\[\\#ECFDF5\\]:focus-visible{
  --tw-ring-offset-color: #ECFDF5;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-default:disabled{
  cursor: default;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:bg-\\[\\#9CA3AF\\]:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-\\[\\#F3F4F6\\]:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.disabled\\:text-\\[\\#9CA3AF\\]:disabled{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-0:disabled{
  opacity: 0;
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:hover\\:border-\\[\\#E7E0D2\\]:hover:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(231 224 210 / var(--tw-border-opacity, 1));
}
.disabled\\:hover\\:text-\\[\\#4B5563\\]:hover:disabled{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.03\\]{
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:text-\\[\\#064E3B\\]{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:underline{
  text-decoration-line: underline;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@supports (backdrop-filter: var(--tw)){

  .supports-\\[backdrop-filter\\]\\:bg-\\[\\#FDFBF7\\]\\/85{
    background-color: rgb(253 251 247 / 0.85);
  }
}
.dark\\:border-\\[\\#22453A\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(34 69 58 / var(--tw-border-opacity, 1));
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
.dark\\:bg-\\[\\#12221D\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(18 34 29 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:from-\\[\\#173D31\\]:is(.dark *){
  --tw-gradient-from: #173D31 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 61 49 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:via-\\[\\#14332B\\]:is(.dark *){
  --tw-gradient-to: rgb(20 51 43 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #14332B var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:to-\\[\\#12221D\\]:is(.dark *){
  --tw-gradient-to: #12221D var(--tw-gradient-to-position);
}
.dark\\:text-\\[\\#B7C2BB\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(183 194 187 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#F3EFE4\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 239 228 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#16302A\\]:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(22 48 42 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#F3EFE4\\]:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 239 228 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:focus-visible\\:ring-offset-\\[\\#173D31\\]:focus-visible:is(.dark *){
  --tw-ring-offset-color: #173D31;
}
@media (max-width: 419px){

  .max-\\[419px\\]\\:hidden{
    display: none;
  }
}
@media (min-width: 420px){

  .min-\\[420px\\]\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:bottom-28{
    bottom: 7rem;
  }

  .sm\\:bottom-6{
    bottom: 1.5rem;
  }

  .sm\\:left-auto{
    left: auto;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:right-6{
    right: 1.5rem;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:h-52{
    height: 13rem;
  }

  .sm\\:max-h-\\[55vh\\]{
    max-height: 55vh;
  }

  .sm\\:min-h-\\[5\\.5rem\\]{
    min-height: 5.5rem;
  }

  .sm\\:w-52{
    width: 13rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:basis-\\[calc\\(33\\.333\\%-0\\.5rem\\)\\]{
    flex-basis: calc(33.333% - 0.5rem);
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-14{
    padding: 3.5rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-7{
    padding: 1.75rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:p-9{
    padding: 2.25rem;
  }

  .sm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:sticky{
    position: sticky;
  }

  .lg\\:top-20{
    top: 5rem;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:basis-\\[calc\\(25\\%-0\\.5625rem\\)\\]{
    flex-basis: calc(25% - 0.5625rem);
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1fr_360px\\]{
    grid-template-columns: 1fr 360px;
  }

  .lg\\:grid-cols-\\[220px_1fr\\]{
    grid-template-columns: 220px 1fr;
  }

  .lg\\:gap-2{
    gap: 0.5rem;
  }

  .lg\\:gap-x-4{
    column-gap: 1rem;
  }

  .lg\\:self-start{
    align-self: flex-start;
  }

  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
}
@media (min-width: 1280px){

  .xl\\:inline{
    display: inline;
  }

  .xl\\:hidden{
    display: none;
  }

  .xl\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .xl\\:gap-x-5{
    column-gap: 1.25rem;
  }
}
@media (min-width: 1536px){

  .\\32xl\\:gap-3{
    gap: 0.75rem;
  }

  .\\32xl\\:gap-x-6{
    column-gap: 1.5rem;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,wBAAc;IAAd,yBAAc;IAAd,iBAAc;IAAd,8BAAc;IAAd,oBAAc;IAAd,iCAAc;IAAd,sBAAc;IAAd,gCAAc;IAAd,uBAAc;IAAd,mCAAc;IAAd,mBAAc;IAAd,8BAAc;IAAd,oBAAc;IAAd,8BAAc;IAAd,wBAAc;IAAd,kCAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,iBAAc;EAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,wCAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;;EAEjB;;;;;;;;;;;;;;;;iEAgB+D;EAC/D,yCAAyC;EACzC,+CAA+C;EAC/C,2CAA2C;EAC3C,6CAA6C;;EAE7C;;;iCAG+B;EAC/B,6CAA6C;AAC/C;;AAEA;;;oEAGoE;AACpE;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,4DAA4D;AAC5D,uBAAuB,yBAAyB,EAAE;;AAElD,0DAA0D;AAC1D,eAAe,kCAAkC,EAAE;;AAEnD,oBAAoB,2BAA2B,EAAE,kBAAkB,EAAE;AACrE;wIACwI;AACxI,aAAa,gBAAgB,EAAE;;AAE/B;;;;;;;0DAO0D;;AAE1D;;;;;;;;;;;;;;;gDAegD;AAChD;;;;;;;;;;;;;;6DAc6D;;AAE7D;;EAEE,mFAAmF;EACnF,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mFAAmF;EACnF,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;mEAYmE;AACnE;;;;EAIE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;aAmBa;AACb;;EAEE,gEAAgE;AAClE;AACA;EACE,gEAAgE;AAClE;AACA;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;;;wEAUwE;AACxE;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT;;;;;;;;;;;cAWY;EACZ,oFAAoF;EACpF,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B;;0EAEwE;EACxE,4BAA4B;AAC9B;;AAEA,gBAAgB,wEAAwE,EAAE,uBAAuB,EAAE;AACnH,gBAAgB,yEAAyE,EAAE;AAC3F;EACE,+DAA+D;EAC/D,cAAc;EACd,qEAAqE;EACrE,kCAAkC;AACpC;;AAEA;;;;;;;;;;;;;;;;iEAgBiE;AACjE;EACE,8DAA8D;EAC9D,kFAAkF;EAClF,gBAAgB;EAChB,cAAc;EACd,6EAA6E;EAC7E,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,8DAA8D;EAC9D,mFAAmF;EACnF,gBAAgB;EAChB,cAAc;EACd,6EAA6E;EAC7E,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;EAEE,mFAAmF;AACrF;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;;sBAEsB;AACtB;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,6EAA6E;EAC7E,kCAAkC;AACpC;AACA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,cAAc;EACd,6EAA6E;EAC7E,kCAAkC;AACpC;AACA;;qEAEqE;AACrE;EACE,8FAA8F;EAC9F,gBAAgB;EAChB,cAAc;EACd;iDAC+C;EAC/C,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,qFAAqF;EACrF,kCAAkC;EAClC,mCAAmC;AACrC;AACA,4EAA4E;AAC5E,uBAAuB,iBAAiB,IAAI,gBAAgB,EAAE;AAC9D,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE;AAC9D,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE;AAC9D,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE;AAC9D;;kDAEkD;AAClD;EACE,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,iBAAiB;EACjB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;uDACuD;AACvD;EACE,+CAA+C;EAC/C,cAAc;EACd,qEAAqE;EACrE,kCAAkC;AACpC;;AAgCA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,uEAAuE;EACvE,qBAAqB;AACvB;AACA;kFACkF;AAClF;;EAEE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;0CAE0C;AAC1C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,8EAA8E;EAC9E,uBAAuB;EACvB,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB;2CACyX;AAC3X;;AAEA,sBAAsB;AACtB;EACE;6EAC2E;EAC3E,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,KAAK,qCAAqC,EAAE;EAC5C,MAAM,sCAAsC,EAAE;EAC9C,OAAO,mCAAmC,EAAE;AAC9C;AACA,kBAAkB,2CAA2C,EAAE;;AAE/D;EACE,WAAW,sBAAsB,EAAE;EACnC,MAAM,oBAAoB,EAAE;AAC9B;AACA,YAAY,wCAAwC,EAAE,wBAAwB,EAAE;;AAEhF,yBAAyB;AACzB;EACE,KAAK,UAAU,EAAE,sBAAsB,EAAE;EACzC,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;AACA,YAAY,iCAAiC,EAAE;;AAE/C;;uEAEuE;AACvE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,kBAAkB,gEAAgE,EAAE;;AAEpF;kCACkC;AAClC;EACE,kBAAkB,eAAe,EAAE;AACrC;;AAEA,+BAA+B;AAC/B,eAAe,uCAAuC,EAAE;;AAExD,yCAAyC;AACzC,WAAW,kBAAkB,EAAE;AAC/B,YAAY,oBAAoB,EAAE,0BAA0B,EAAE,2BAA2B,EAAE,0CAA0C,EAAE;AACvI,aAAa,oBAAoB,EAAE,aAAa,EAAE,6BAA6B,EAAE;AACjF,cAAc,oBAAoB,EAAE,kBAAkB,EAAE;;AAExD,gBAAgB;AAChB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;AAteA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,mBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA,QAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA,sBAueA;EAveA;AAueA;AAveA;EAAA,iDAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kDAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA,kBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,gDAueA;EAveA,6DAueA;EAveA;AAueA;AAveA;EAAA,iDAueA;EAveA,6DAueA;EAveA;AAueA;AAveA;EAAA,gDAueA;EAveA,4DAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,8BAueA;EAveA;AAueA;AAveA;EAAA,2GAueA;EAveA,yGAueA;EAveA;AAueA;AAveA;EAAA,2GAueA;EAveA,yGAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,8BAueA;EAveA;AAueA;AAveA;EAAA,2GAueA;EAveA,yGAueA;EAveA;AAueA;AAveA;EAAA,2GAueA;EAveA,yGAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,iBAueA;EAveA,iBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA,kBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,yBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA,kBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,+EAueA;EAveA,mGAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,yBAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,yBAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA,qBAueA;EAveA;AAueA;AAveA;EAAA,qBAueA;EAveA;AAueA;AAveA;EAAA,gDAueA;EAveA;AAueA;AAveA;EAAA,iDAueA;EAveA;AAueA;AAveA;;EAAA;IAAA;EAueA;;EAveA;IAAA;EAueA;AAAA;AAveA;EAAA;AAueA;AAveA;;EAAA;IAAA;EAueA;;EAveA;IAAA;EAueA;AAAA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,0EAueA;EAveA,8FAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,qBAueA;EAveA,yBAueA;EAveA,2BAueA;EAveA,yBAueA;EAveA,0BAueA;EAveA,+BAueA;EAveA;AAueA;AAveA;EAAA,qBAueA;EAveA,yBAueA;EAveA,2BAueA;EAveA,yBAueA;EAveA,0BAueA;EAveA,+BAueA;EAveA;AAueA;AAveA;EAAA,qBAueA;EAveA,yBAueA;EAveA,2BAueA;EAveA,yBAueA;EAveA,0BAueA;EAveA,+BAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA,yBAueA;EAveA,0BAueA;EAveA,wBAueA;EAveA,yBAueA;EAveA,8BAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA,yBAueA;EAveA,0BAueA;EAveA,wBAueA;EAveA,yBAueA;EAveA,8BAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA,yBAueA;EAveA,0BAueA;EAveA,wBAueA;EAveA,yBAueA;EAveA,8BAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA,yBAueA;EAveA,0BAueA;EAveA,wBAueA;EAveA,yBAueA;EAveA,8BAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA,sBAueA;EAveA;AAueA;AAveA;EAAA,0BAueA;EAveA,qBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,mBAueA;EAveA;AAueA;AAveA;;EAAA;IAAA;EAueA;AAAA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,4DAueA;EAveA,kEAueA;EAveA;AAueA;AAveA;EAAA,mEAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;;EAAA;IAAA;EAueA;AAAA;AAveA;;EAAA;IAAA,qBAueA;IAveA;EAueA;AAAA;AAveA;;EAAA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA,oBAueA;IAveA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA,uBAueA;IAveA,sDAueA;IAveA;EAueA;;EAveA;IAAA,uBAueA;IAveA,oDAueA;IAveA;EAueA;;EAveA;IAAA,uBAueA;IAveA,2DAueA;IAveA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA,oBAueA;IAveA;EAueA;;EAveA;IAAA,qBAueA;IAveA;EAueA;;EAveA;IAAA,oBAueA;IAveA;EAueA;;EAveA;IAAA,kBAueA;IAveA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA,iBAueA;IAveA;EAueA;;EAveA;IAAA,mBAueA;IAveA;EAueA;;EAveA;IAAA,kBAueA;IAveA;EAueA;;EAveA;IAAA,eAueA;IAveA;EAueA;;EAveA;IAAA,kBAueA;IAveA;EAueA;;EAveA;IAAA,iBAueA;IAveA;EAueA;;EAveA;IAAA,mBAueA;IAveA;EAueA;;EAveA;IAAA;EAueA;AAAA;AAveA;;EAAA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA,mBAueA;IAveA;EAueA;AAAA;AAveA;;EAAA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA,kBAueA;IAveA;EAueA;;EAveA;IAAA,kBAueA;IAveA;EAueA;AAAA;AAveA;;EAAA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;;EAveA;IAAA;EAueA;AAAA;AAveA;;EAAA;IAAA;EAueA;;EAveA;IAAA;EAueA;AAAA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,kDAueA;EAveA;AAueA;AAveA;EAAA,iDAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,iDAueA;EAveA;AAueA;AAveA;EAAA,kDAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kDAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,qBAueA;EAveA;AAueA;AAveA;EAAA,gBAueA;EAveA,oBAueA;EAveA,4BAueA;EAveA;AAueA;AAveA;EAAA,sBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,WAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA,mBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,qBAueA;EAveA;AAueA;AAveA;EAAA,kBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA,oBAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA,WAueA;EAveA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA;AAveA;EAAA;AAueA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Figtree:wght@300;400;500;600;700&family=Amiri:wght@400;700&family=Amiri+Quran&family=Scheherazade+New:wght@400;500;600;700&family=Noto+Naskh+Arabic:wght@400;500;600;700&family=Noto+Sans+Arabic:wght@400;500;600;700;800&family=Noto+Sans+Tamil:wght@300;400;500;600;700;800&family=Noto+Nastaliq+Urdu:wght@400;500;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --bg: #FDFBF7;\n  --surface: #FFFFFF;\n  --primary: #064E3B;\n  --primary-hover: #047857;\n  --accent: #D97706;\n  --accent-hover: #B45309;\n  --text: #1F2937;\n  --text-soft: #4B5563;\n  --border: #E7E0D2;\n  --success: #10B981;\n  --danger: #EF4444;\n\n  /* ----------------------------------------------------------\n     iOS safe areas (notch / Dynamic Island / home indicator)\n     ----------------------------------------------------------\n     index.html sets `viewport-fit=cover` together with\n     `apple-mobile-web-app-status-bar-style=black-translucent`, and the\n     manifest sets `display: standalone`. That combination tells iOS to\n     draw the web view edge-to-edge — *underneath* the status bar and\n     Dynamic Island — once the PWA is added to the home screen. Nothing\n     compensated for it, so the sticky header (logo, A-/A+, language\n     picker, Sign in) rendered beneath the clock and any incoming\n     notification banner, where iOS keeps the touches for itself: those\n     controls were both visually covered and untappable.\n\n     env() reports how much each edge reserves, and resolves to the 0px\n     fallback anywhere without insets — so all of this is inert on\n     Android, desktop, and in a normal browser tab.\n     ---------------------------------------------------------- */\n  --safe-top: env(safe-area-inset-top, 0px);\n  --safe-bottom: env(safe-area-inset-bottom, 0px);\n  --safe-left: env(safe-area-inset-left, 0px);\n  --safe-right: env(safe-area-inset-right, 0px);\n\n  /* The header's own height (its `min-h-16` = 4rem) plus whatever the\n     status bar reserves above it. Anything that sticks directly *below*\n     the header has to offset by this, or it slides underneath once the\n     header grows by the inset. */\n  --header-offset: calc(4rem + var(--safe-top));\n}\n\n/* Sticky app header: push its contents clear of the status bar while the\n   translucent background still bleeds up behind it, so the strip stays\n   tinted instead of opening a bare gap above the header. The left/right\n   insets matter in landscape, where the notch eats into one side. */\n.safe-header {\n  padding-top: var(--safe-top);\n  padding-left: var(--safe-left);\n  padding-right: var(--safe-right);\n}\n\n/* Toolbars that stick immediately beneath the app header. */\n.sticky-below-header { top: var(--header-offset); }\n\n/* Keeps trailing page content above the home indicator. */\n.safe-bottom { padding-bottom: var(--safe-bottom); }\n\nhtml, body, #root { background-color: var(--bg); color: var(--text); }\n/* The header toolbar is ~23px wider than a 390px phone. Without this the phone widens its layout viewport, which pushes\n   fixed-position controls (the demo strip, the chat button) partly off screen. `clip`, unlike `hidden`, keeps sticky headers working. */\nhtml, body { overflow-x: clip; }\n\n/* Alvi Nastaleeq's @font-face lives in public/fonts/alvi-nastaleeq.css,\n   linked directly from index.html — NOT here. CRA's css-loader treats any\n   url() inside webpack-processed CSS (this file) as a JS module request,\n   even root-absolute ones like url('/fonts/...'), so it can't reference a\n   plain public/ asset without failing to compile (\"Cannot find module\n   '/fonts/AlviNastaleeq.woff2'\"). A separate stylesheet served as-is from\n   public/ has no such restriction — the browser resolves its url()s\n   against the site root like any other static CSS file. */\n\n/* Urdu UI chrome — swaps the Noto Sans Arabic fallback (Naskh-style, used\n   for Tamil/Arabic UI text generally) for the Nastaliq calligraphic style\n   Urdu is conventionally set in. Scoped to [lang=\"ur\"], which I18nContext\n   stamps on <html> whenever the active UI language is Urdu, so switching\n   back to any other language reverts instantly.\n\n   Two Latin-type habits actively fight a cursive joined script and were\n   the actual cause of the \"clumsy/overlapping\" look, not the font itself:\n     - .font-heading's -0.01em letter-spacing (tight tracking reads as\n       \"modern\" on Outfit's Latin glyphs) forces extra overlap on top of\n       Nastaleeq's own designed joins, since the glyphs are already\n       touching by design — needs resetting to normal, not just inherited.\n     - The default ~1.2–1.5 line-height leaves no room for Nastaliq's\n       steep diagonal ascender/descender strokes and stacked diacritics,\n       which need roughly double a Latin line's height to clear the line\n       above/below without visually colliding. */\n/* Nastaliq's thin strokes and calligraphic proportions carry far less\n   visual weight than a bold Latin sans at the same declared font-size —\n   text that measures identically in px still *reads* noticeably smaller\n   and lighter. The actual root font-size boost for Urdu lives in\n   App.js's FontSizeDomSync, NOT as a plain `html[lang=\"ur\"] { font-size }`\n   rule here — the existing A-/A+ accessibility control\n   (FontSizeContext) writes an inline style to <html>, which always wins\n   over any stylesheet rule regardless of specificity, so a CSS-only\n   attempt here would have silently done nothing. Scaling the root\n   font-size (rather than font-size on individual text classes) is the\n   right lever either way: nearly every size AND spacing utility in this\n   app (text-*, p-*, gap-*, w-*, etc.) is expressed in rem, which resolves\n   against <html>'s font-size — so one number grows text, padding, and\n   gaps together in proportion, instead of enlarging only the glyphs and\n   leaving them cramped inside now-too-small buttons/cards. */\n\nhtml[lang=\"ur\"] body,\nhtml[lang=\"ur\"] .font-body {\n  font-family: 'Alvi Nastaleeq', 'Noto Nastaliq Urdu', 'Noto Sans Arabic', sans-serif;\n  line-height: 2.1;\n  letter-spacing: normal;\n  font-weight: 400;\n}\nhtml[lang=\"ur\"] .font-heading {\n  font-family: 'Alvi Nastaleeq', 'Noto Nastaliq Urdu', 'Noto Sans Arabic', sans-serif;\n  letter-spacing: normal;\n  line-height: 1.9;\n  font-weight: 400;\n}\n\n/* Client feedback: no bold in Alvi Nastaleeq, size only. The @font-face\n   above only registers one weight (400, see alvi-nastaleeq.css) — every\n   heading/button in the app applies a Tailwind weight utility on top\n   (font-medium/semibold/bold) for the Latin faces, and with no matching\n   700-weight file for Nastaleeq the browser was faking it by algorithmically\n   thickening the strokes (\"font synthesis\"). That distorts a calligraphic,\n   diagonally-joined script far more than it does a Latin sans — this is\n   the actual cause of the heavy/clumsy look in the screenshot, not the\n   font itself. Fix is two-layered: reset the common weight utilities back\n   to the font's one true regular weight (specificity of an attribute\n   selector + class beats a bare utility class, so this wins regardless of\n   which order the classes were written in JSX), and disable font-synthesis\n   outright as a backstop for anything not covered by name below. */\nhtml[lang=\"ur\"] .font-medium,\nhtml[lang=\"ur\"] .font-semibold,\nhtml[lang=\"ur\"] .font-bold,\nhtml[lang=\"ur\"] .font-extrabold {\n  font-weight: 400;\n}\nhtml[lang=\"ur\"] body {\n  font-synthesis: none;\n}\n\n/* TAU_Elango_Kalyani's @font-face lives in public/fonts/kalyani.css,\n   linked directly from index.html — same CRA css-loader constraint as\n   Alvi Nastaleeq above. Scoped to [lang=\"ta\"], which I18nContext stamps\n   on <html> whenever the active UI language is Tamil.\n\n   Majidi was tried first (see majidi.css, still self-hosted but unused\n   below) — this replaced it as the active choice.\n\n   Reported as \"blurry at normal size, clear when zoomed in\" — that's\n   the signature of thin strokes not getting enough anti-aliased pixel\n   coverage at typical UI text sizes, not a rendering bug. Confirmed via\n   fontTools: this font's base letterforms fill only ~48% of the\n   em-square (vs. a noticeably taller design in most UI-oriented Tamil\n   fonts), so the same declared px font-size reads smaller/lighter than\n   the Noto Sans Tamil fallback it replaced — same root cause as Alvi\n   Nastaleeq's Urdu boost above, smaller correction since this is an\n   upright script with no RTL joining to fight. font-synthesis: none is\n   the backstop for the @font-face's 100–900 weight range in\n   kalyani.css — belt-and-suspenders against any fake-bold slipping\n   through. */\nhtml[lang=\"ta\"] body,\nhtml[lang=\"ta\"] .font-body {\n  font-family: 'TAU Elango Kalyani', 'Noto Sans Tamil', sans-serif;\n}\nhtml[lang=\"ta\"] .font-heading {\n  font-family: 'TAU Elango Kalyani', 'Noto Sans Tamil', sans-serif;\n}\nhtml[lang=\"ta\"] body {\n  font-synthesis: none;\n}\n\n/* RTL icon mirroring — lucide-react auto-classes every icon it renders as\n   `lucide-{icon-name}` (see createLucideIcon.js), so these are stable\n   selector hooks with no per-usage markup needed. Play, Arrow-right/left,\n   and Chevron-right/left icons read as \"forward\" (continue, next, tap-\n   to-advance) everywhere they're\n   used in this app; in a right-to-left layout \"forward\" points left, not\n   right, so mirror them horizontally whenever the page itself is RTL\n   (Urdu today — keyed on the `dir` attribute I18nContext sets on <html>,\n   not on [lang=\"ur\"] specifically, so any future RTL locale picks this up\n   for free). Flipping both the *-right and *-left variants together swaps\n   their meaning correctly instead of just rotating one of them wrong. */\nhtml[dir=\"rtl\"] .lucide-play,\nhtml[dir=\"rtl\"] .lucide-arrow-right,\nhtml[dir=\"rtl\"] .lucide-arrow-left,\nhtml[dir=\"rtl\"] .lucide-chevron-right,\nhtml[dir=\"rtl\"] .lucide-chevron-left {\n  transform: scaleX(-1);\n}\n\nbody {\n  margin: 0;\n  /* Figtree/Outfit only cover Latin glyphs, so switching the UI language to\n     Tamil or Urdu previously fell through to whatever Tamil/Arabic font the\n     visitor's OS happened to ship — an unpredictable fallback with taller\n     glyph metrics than Figtree at the same font-size, which is what made\n     translated UI chrome (nav, buttons, cards, forms) look larger and shift\n     layout. Noto Sans Tamil / Noto Sans Arabic are explicitly designed by\n     Google as part of the same Noto family for near-identical cap-height/\n     x-height across scripts, so they slot in at the declared font-size\n     without the layout-shifting side effect — this only ever engages for\n     glyphs Figtree/Outfit don't have; English (and other Latin UI text:\n     French, Bahasa Melayu, Swahili) is rendered in Figtree exactly as\n     before. */\n  font-family: 'Figtree', 'Noto Sans Tamil', 'Noto Sans Arabic', system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg);\n  background-image:\n    radial-gradient(at 12% 8%, rgba(6,78,59,0.06) 0px, transparent 50%),\n    radial-gradient(at 88% 92%, rgba(217,119,6,0.05) 0px, transparent 50%);\n  background-attachment: fixed;\n}\n\n.font-heading { font-family: 'Outfit', 'Noto Sans Tamil', 'Noto Sans Arabic', sans-serif; letter-spacing: -0.01em; }\n.font-body    { font-family: 'Figtree', 'Noto Sans Tamil', 'Noto Sans Arabic', sans-serif; }\n.font-arabic  {\n  font-family: 'Noto Sans Arabic', 'Scheherazade New', sans-serif;\n  direction: rtl;\n  font-feature-settings: \"calt\", \"kern\", \"liga\", \"rlig\", \"mark\", \"mkmk\";\n  text-rendering: optimizeLegibility;\n}\n\n/* ============================================================\n   SCRIPT (MUSHAF) SWITCHING\n   ------------------------------------------------------------\n   The .font-quran and .font-mushaf-prose classes change their\n   underlying font-family based on the <html data-script>\n   attribute set by ScriptSettingsContext.\n\n   * Uthmani (default): Amiri Quran — the closest open-source\n     match to the Madinah Mushaf. Used across the Arab world,\n     Malaysia, Indonesia.\n   * Indo-Pak:          Scheherazade New + Noto Naskh Arabic\n     fallback — closely mirrors the Saleem/Noorehira glyph\n     metrics popular in Pakistan, India, Bangladesh.\n\n   Both share OpenType ligature features so \"الله\" renders with\n   the correct dagger-alif and ligation in both modes.\n   ============================================================ */\n.font-quran   {\n  /* default — overridden by [data-script=...] selectors below */\n  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', serif;\n  font-weight: 500;\n  direction: rtl;\n  font-feature-settings: \"calt\", \"kern\", \"liga\", \"rlig\", \"dlig\", \"mark\", \"mkmk\";\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n}\n.font-mushaf-prose {\n  /* default — overridden by [data-script=...] selectors below */\n  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Naskh Arabic', serif;\n  font-weight: 500;\n  direction: rtl;\n  font-feature-settings: \"calt\", \"kern\", \"liga\", \"rlig\", \"dlig\", \"mark\", \"mkmk\";\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n}\n\nhtml[data-script=\"uthmani\"] .font-quran,\nhtml[data-script=\"uthmani\"] .font-mushaf-prose {\n  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Naskh Arabic', serif;\n}\n\nhtml[data-script=\"indopak\"] .font-quran,\nhtml[data-script=\"indopak\"] .font-mushaf-prose {\n  font-family: 'Scheherazade New', 'Noto Naskh Arabic', 'Amiri', serif;\n}\n\n/* Visual-only preview helpers used by ScriptPicker so the side-by-side\n   tiles always render in their intended font regardless of the current\n   global selection. */\n.font-preview-uthmani {\n  font-family: 'Amiri Quran', 'Amiri', serif;\n  font-weight: 500;\n  direction: rtl;\n  font-feature-settings: \"calt\", \"kern\", \"liga\", \"rlig\", \"dlig\", \"mark\", \"mkmk\";\n  text-rendering: optimizeLegibility;\n}\n.font-preview-indopak {\n  font-family: 'Scheherazade New', 'Noto Naskh Arabic', serif;\n  font-weight: 500;\n  direction: rtl;\n  font-feature-settings: \"calt\", \"kern\", \"liga\", \"rlig\", \"dlig\", \"mark\", \"mkmk\";\n  text-rendering: optimizeLegibility;\n}\n/* Madani-locked class — always uses Amiri Quran (KFGQPC Uthman Taha\n   equivalent). Used by Module 9 so the final recitation always renders\n   in the Madani Mushaf regardless of the user's script_preference. */\n.font-madani {\n  font-family: 'Amiri Quran', 'Amiri', 'Scheherazade New', 'Noto Naskh Arabic', serif !important;\n  font-weight: 500;\n  direction: rtl;\n  /* Generous line-height so dagger-alif (ٰ) + shaddah (ّ) marks don't\n     collide with descenders on the line below. */\n  line-height: 3.4;\n  word-spacing: 0.15em;\n  letter-spacing: 0;\n  font-feature-settings: \"calt\", \"kern\", \"liga\", \"rlig\", \"dlig\", \"mark\", \"mkmk\", \"ss01\";\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n}\n/* Per-step size variants used by the Madani font-size picker on Module 9. */\n.font-madani.size-sm { font-size: 1.5rem;   line-height: 3.0; }\n.font-madani.size-md { font-size: 1.875rem; line-height: 3.4; }\n.font-madani.size-lg { font-size: 2.375rem; line-height: 3.6; }\n.font-madani.size-xl { font-size: 2.875rem; line-height: 3.8; }\n/* Red-word highlight for Module 9 — words already practiced in Modules 1-7.\n   Bolder, slightly larger, with a soft amber under-glow so they pop on the\n   emerald background without looking pasted-on. */\n.qf-red-word {\n  color: #FCA5A5;\n  font-weight: 700;\n  text-shadow: 0 0 12px rgba(239, 68, 68, 0.45);\n  padding: 0 0.05em;\n  border-radius: 4px;\n  background: linear-gradient(180deg, transparent 65%, rgba(239, 68, 68, 0.18) 65%);\n}\n\n/* Mushaf-style class — uses Scheherazade New (high-quality open Naskh that\n   closely mirrors the Madinah Mushaf glyph metrics). */\n.font-mushaf  {\n  font-family: 'Scheherazade New', 'Amiri', serif;\n  direction: rtl;\n  font-feature-settings: \"calt\", \"kern\", \"liga\", \"rlig\", \"mark\", \"mkmk\";\n  text-rendering: optimizeLegibility;\n}\n\n@layer base {\n  :root {\n    --background: 38 50% 98%;\n    --foreground: 220 14% 18%;\n    --card: 0 0% 100%;\n    --card-foreground: 220 14% 18%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 220 14% 18%;\n    --primary: 162 86% 17%;\n    --primary-foreground: 38 50% 98%;\n    --secondary: 38 30% 94%;\n    --secondary-foreground: 162 86% 17%;\n    --muted: 38 30% 94%;\n    --muted-foreground: 220 9% 40%;\n    --accent: 32 95% 44%;\n    --accent-foreground: 0 0% 100%;\n    --destructive: 0 84% 60%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 38 20% 88%;\n    --input: 38 20% 88%;\n    --ring: 162 86% 17%;\n    --radius: 0.75rem;\n  }\n}\n\n@layer base {\n  * { @apply border-border; }\n  body { @apply bg-background text-foreground; }\n}\n\n/* Arabic typography polish */\n.font-arabic, .font-quran {\n  line-height: 1.9;\n  letter-spacing: 0;\n  word-spacing: 0.05em;\n  /* Prevent breaking inside a word and avoid the scattered-letter look */\n  unicode-bidi: isolate;\n}\n/* When Quranic prose runs as a paragraph, keep words intact and let lines wrap\n   naturally — overrides Tailwind's `leading-loose` so glyph stacks don't drift. */\n.font-quran p,\n.font-quran {\n  word-break: keep-all;\n  overflow-wrap: break-word;\n}\n\n/* Mushaf prose — Noto Naskh Arabic renders comfortably at 2.0 line-height\n   (Amiri Quran needed 2.4 for stacked diacritics, Noto Naskh handles them\n   inline so we can tighten the rhythm). */\n.font-mushaf-prose {\n  line-height: 2.0;\n  letter-spacing: 0;\n  word-spacing: 0.08em;\n  unicode-bidi: isolate;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n}\n\n/* Madinah-style Mushaf line — each line in a page is one stretched-justified row */\n.mushaf-line-row {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: baseline;\n  justify-content: space-between;\n  width: 100%;\n  font-size: clamp(1.6rem, 2.6vw, 2.4rem);\n  line-height: 2.4;\n  white-space: nowrap;\n  overflow: hidden;\n  text-align: justify;\n  text-align-last: justify;\n}\n.mushaf-line-row > * { white-space: nowrap; }\n.mushaf-line-short {\n  /* Last line of a surah is naturally short — center it instead of stretching */\n  justify-content: center;\n  gap: 0.4em;\n}\n\n/* Subtle parchment grain */\n.parchment {\n  background-color: #FDFBF7;\n  background-image:\n    url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0.95  0 0 0 0 0.92  0 0 0 0 0.86  0 0 0 0.05 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n}\n\n/* Geometric pattern */\n.pattern-islamic {\n  background-image:\n    radial-gradient(circle at 1px 1px, rgba(6,78,59,0.08) 1px, transparent 0);\n  background-size: 24px 24px;\n}\n\n/* Waveform pulse for recording */\n@keyframes pulseRing {\n  0% { box-shadow: 0 0 0 0 rgba(6,78,59,0.4); }\n  70% { box-shadow: 0 0 0 24px rgba(6,78,59,0); }\n  100% { box-shadow: 0 0 0 0 rgba(6,78,59,0); }\n}\n.recording-ring { animation: pulseRing 1.4s ease-out infinite; }\n\n@keyframes bar {\n  0%, 100% { transform: scaleY(0.3); }\n  50% { transform: scaleY(1); }\n}\n.wave-bar { animation: bar 0.9s ease-in-out infinite; transform-origin: bottom; }\n\n/* Word card flip enter */\n@keyframes flashIn {\n  0% { opacity: 0; transform: scale(0.94); }\n  100% { opacity: 1; transform: scale(1); }\n}\n.flash-in { animation: flashIn 240ms ease-out; }\n\n/* Install surfaces (landing CTA + dashboard card) fade and slide in. They\n   appear only once the browser fires `beforeinstallprompt`, which can land a\n   moment after paint — so they'd otherwise pop in abruptly mid-page. */\n@keyframes installReveal {\n  0%   { opacity: 0; transform: translateY(10px); }\n  100% { opacity: 1; transform: translateY(0); }\n}\n.install-reveal { animation: installReveal 420ms cubic-bezier(0.4, 0, 0.2, 1) both; }\n\n/* Honour the OS \"reduce motion\" setting — the element still appears, it just\n   arrives without the movement. */\n@media (prefers-reduced-motion: reduce) {\n  .install-reveal { animation: none; }\n}\n\n/* Mushaf reading transitions */\n.mushaf-line { transition: background-color 200ms ease; }\n\n/* Diff highlights for voice recitation */\n.diff-ok { color: var(--text); }\n.diff-sub { color: var(--danger); text-decoration: underline; text-decoration-style: wavy; text-decoration-color: rgba(239,68,68,0.6); }\n.diff-miss { color: var(--danger); opacity: 0.55; text-decoration: line-through; }\n.diff-extra { color: var(--accent); font-style: italic; }\n\n/* Focus rings */\nbutton:focus-visible, a:focus-visible, input:focus-visible, textarea:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n  border-radius: 6px;\n}\n\n/* Brand gradient text */\n.brand-gradient {\n  background: linear-gradient(115deg, #064E3B 0%, #047857 50%, #D97706 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
